<script lang="ts">
    import cn from 'classnames';
    import { onMount } from 'svelte';
    import { sendGdprEvent } from '$lib/services/gtm/methods';

    import { acceptCookies } from '@api/user';
    import { sendStats } from '@api/user/stats';
    import { StickyNotification } from '@components/common/sticky-notification';
    import { globalStore } from '@components/stores';
    import { LL } from '@i18n/i18n-svelte';
    import { URLS } from '@shared/routing';
    import { EventCategory, EventType } from '@shared/types/stats';
    import { Button, ButtonTypes } from '@uikit/button';
    import { Font, FontTypes } from '@uikit/font';
    import { Size } from '@uikit/types';

    import s from './allow-cookies.module.css';

    export let isAuth: boolean;

    const privacyLink = URLS.privacyPolicy();

    function allowCookies() {
        if (isAuth) {
            acceptCookies().then(globalStore.allowCookies);
        } else {
            globalStore.allowCookies();
        }
        sendGdprEvent({ event: EventType.GdprClickAccept });
        sendStats(EventType.GdprClickAccept, EventCategory.Gdpr, $globalStore.isDesktopSite);
    }

    onMount(() => {
        sendGdprEvent({ event: EventType.GdprModalShow });
        sendStats(EventType.GdprModalShow, EventCategory.Gdpr, $globalStore.isDesktopSite);
    });
</script>

<StickyNotification>
    <aside class={cn(s.inner, { [s.desktop]: $globalStore.isDesktopSite })}>
        <Font
            tagName={FontTypes.TagName.p}
            type={$globalStore.isDesktopSite ? FontTypes.Type.body : FontTypes.Type.caption}
            className={cn(s.description)}
        >
            {@html $LL.cookiesPopup.description({ link: privacyLink })}
        </Font>
        <Button
            classes={cn(s.button)}
            fullWidth={!$globalStore.isDesktopSite}
            color={ButtonTypes.Color.Brand}
            size={$globalStore.isDesktopSite ? undefined : Size.Small}
            on:click={allowCookies}
            attrs={{ 'data-testid': 'acceptButton' }}
        >
            {$LL.cookiesPopup.buttonLabel()}
        </Button>
    </aside>
</StickyNotification>
